const AbonnementGroupIntegrated = ({language , token}) => {
    const newAbonnementGroupIframe = "https:" +
    window.process.env.URL_Abonnement_Group
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_abonnement_group_display"
        src={newAbonnementGroupIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default AbonnementGroupIntegrated